const doesAnythingNeedPosting = function (state) {
    if (state.manufacturer !== state.lastPostedState.manufacturer ||
        state.model.id !== state.lastPostedState.model.id ||
        state.gearboxChoice !== state.lastPostedState.gearboxChoice ||
        state.fuelTypeChoice !== state.lastPostedState.fuelTypeChoice ||
        state.trimChoice !== state.lastPostedState.trimChoice ||
        state.engineChoice !== state.lastPostedState.engineChoice ||
        state.vehicleId !== state.lastPostedState.vehicleId ||
        state.interiorChoice !== state.lastPostedState.interiorChoice ||
        state.paintChoice !== state.lastPostedState.paintChoice ||
        state.configuratorId !== state.lastPostedState.configuratorId ||
        state.firstName !== state.lastPostedState.firstName ||
        state.lastName !== state.lastPostedState.lastName ||
        state.email !== state.lastPostedState.email) {

        return true;
    }

    return false;
};

export {doesAnythingNeedPosting};


// WEBPACK FOOTER //
// ./resources/assets/js/configurator/store/modules/doesAnythingNeedPosting.js